import { ErrorHandler, Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly errorHandler = inject(ErrorHandler);

  error(message: string, error?: Error): void {
    // In production, this could send to monitoring service (Sentry, LogRocket, etc.)
    if (error) {
      this.errorHandler.handleError(error);
    } else {
      this.errorHandler.handleError(new Error(message));
    }
  }

  info(message: string): void {
    // In production, this could send to logging service
    if (this.isDevelopment()) {
      // Only log in development
      console.info(message);
    }
  }

  warn(message: string): void {
    // In production, this could send to monitoring service
    if (this.isDevelopment()) {
      console.warn(message);
    }
  }

  private isDevelopment(): boolean {
    return !this.isProduction();
  }

  private isProduction(): boolean {
    // Check if running in production mode
    if (typeof window === 'undefined') {
      return false;
    }

    const hostname = window.location.hostname;
    const isDev = /localhost|127\.0\.0\.1|\.local$/.test(hostname);

    return !isDev;
  }
}
